<ng-content></ng-content>

<div class="content mt-3" [attr.id]="tabPanedId">
  <ng-container [ngTemplateOutlet]="activeTemplate"></ng-container>
</div>
